import axios from "./axios";

const reviewApi = {
  listReviews: (tourId) => axios.get(`/reviews?tour_id=${tourId}`),
  createReview: (reviewData) => axios.post("/reviews", reviewData),
  // Admin APIs
  listAllReviews: () => axios.get("/admin/reviews"),
  getReviewStats: () => axios.get("/admin/reviews/stats"),
  deleteReview: (id) => axios.delete(`/admin/reviews/${id}`),
};

export default reviewApi;
